import React from 'react';
import LoginHeader from '../../components/LoginHeader';

function NotFound() {
  return (
    <div className="gray">
      <LoginHeader />

      <section className="login">
        <div className="container">
          <h2>Página não encontrada</h2>
        </div>
      </section>
    </div>
  );
}

export default NotFound;
